{
  "shell": {
    "headline": "Уся ваша школа — в одному просторі.",
    "subheadline": "Увійдіть, щоб продовжити: уроки, класи та успішність — усе в одному місці.",
    "highlights": {
      "school": {
        "title": "Для шкіл і репетиторів",
        "text": "Керуйте школою з командою вчителів або навчайте самостійно — платформа підлаштується."
      },
      "secure": {
        "title": "Приватність і безпека",
        "text": "Кожна роль бачить лише своє: адміністратори, вчителі, учні та батьки."
      },
      "bilingual": {
        "title": "Англійська та українська",
        "text": "Уся платформа говорить обома мовами — перемикайте будь-коли."
      }
    }
  },
  "login": {
    "title": "Вхід",
    "description": "Увійдіть до свого облікового запису Osvitly.",
    "email": "Електронна пошта",
    "emailPlaceholder": "you@school.edu",
    "password": "Пароль",
    "forgotPassword": "Забули пароль?",
    "submit": "Увійти",
    "submitting": "Вхід…",
    "noAccount": "Вперше в Osvitly?",
    "registerLink": "Створити обліковий запис",
    "failed": "Не вдалося ввійти"
  },
  "register": {
    "title": "Створіть обліковий запис",
    "description": "Один обліковий запис для всіх ваших шкіл.",
    "firstName": "Ім'я",
    "lastName": "Прізвище",
    "email": "Електронна пошта",
    "password": "Пароль",
    "confirmPassword": "Підтвердьте пароль",
    "submit": "Зареєструватися",
    "submitting": "Реєстрація…",
    "haveAccount": "Уже маєте обліковий запис?",
    "loginLink": "Увійти",
    "failed": "Не вдалося зареєструватися",
    "verifyEmailTitle": "Перевірте пошту",
    "verifyEmailText": "Ми надіслали лист із підтвердженням на {{email}}. Підтвердьте пошту та увійдіть.",
    "goToLogin": "Перейти до входу"
  },
  "forgot": {
    "title": "Відновлення пароля",
    "description": "Вкажіть свою пошту в Osvitly — ми надішлемо посилання для відновлення.",
    "sentDescription": "Якщо для цієї пошти існує обліковий запис, лист уже в дорозі.",
    "email": "Електронна пошта",
    "submit": "Надіслати посилання",
    "submitting": "Надсилання…",
    "backToLogin": "Повернутися до входу"
  },
  "reset": {
    "title": "Новий пароль",
    "description": "Придумайте пароль для свого облікового запису Osvitly.",
    "doneDescription": "Готово! Тепер увійдіть до Osvitly.",
    "newPassword": "Новий пароль",
    "confirmPassword": "Підтвердьте пароль",
    "submit": "Встановити пароль",
    "submitting": "Збереження…",
    "continueToLogin": "Перейти до входу",
    "linkMissing": "У посиланні бракує токена безпеки. Відкрийте останній лист або запросіть новий.",
    "linkInvalid": "Посилання недійсне або протерміноване. Запросіть новий лист для відновлення.",
    "backToLogin": "Повернутися до входу"
  },
  "invite": {
    "checking": "Перевіряємо запрошення…",
    "bannerTitle": "Вас запрошено",
    "bannerText": "{{name}} запрошує вас приєднатися до «{{school}}» у ролі: {{role}}.",
    "bannerClass": "Клас: {{class}}",
    "emailLocked": "Адресу ел. пошти визначає запрошення.",
    "invalidTitle": "Це посилання-запрошення недійсне",
    "invalidText": "Можливо, воно прострочене або вже використане. Ви все одно можете створити акаунт без нього.",
    "plainSignup": "Зареєструватися звичайним способом"
  },
  "validation": {
    "emailRequired": "Вкажіть електронну пошту",
    "emailInvalid": "Вкажіть дійсну адресу електронної пошти",
    "passwordRequired": "Вкажіть пароль",
    "passwordMin": "Щонайменше 8 символів",
    "passwordConfirmRequired": "Підтвердьте пароль",
    "passwordMismatch": "Паролі не збігаються",
    "firstNameRequired": "Вкажіть ім'я",
    "lastNameRequired": "Вкажіть прізвище"
  },
  "userMenu": {
    "open": "Відкрити меню користувача",
    "signOut": "Вийти"
  }
}
